<template>
    <div class="container bg-white relative outline-none rounded-md shadow-lg flex flex-col mx-auto" @click.stop="" style="max-width:640px; min-width: 280px; max-height: 80vh;">
        <div class="absolute right-0 top-0 text-white bg-primary-600 text-xl p-2 cursor-pointer rounded-t-md" @click="close">X</div>
        
        <div class="text-white text-xl p-2 pr-8 bg-primary-600 rounded-t-md">Important notice</div>
        <div class="flex flex-grow w-full bg-primary-600 relative">
            <!-- Background Image -->
            
            <div class="left-0 h-full">
                <img src="./notificationbackground.jpg" style="height: 100%; width: auto;" />
            </div>

            <!-- Text Content -->
            <div class="absolute inset-0 flex flex-row items-center">
                <div class="w-1o2 text-white px-2 text-4xl text-center">{{title}}</div>
            </div>
        </div>

        <div class="px-4 overflow-scroll flex-1" style="max-height: 50vh">
            <div class="py-2 ck-content" v-html="body"></div>
        </div>
        <div class="border-t py-2 px-4">
            <div class="float-right btn btn-primary" @click="close">Continue</div>
            <div class="clearfix"></div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: String,
        body: String,
    },
    methods: {
        close() {
            this.$emit('close')
        }
    }
}
</script>